<template>
  <MonitorWrapper>
    <div class="security-guard-container" :style="{ fontSize: `${basicFontSize}px` }">
      <div class="part-container">
        <div class="part1">
          <div class="row row1 left">
            <div class="col">{{ list[0].name }}：{{ list[0].value }}{{ list[0].unitName }}</div>
            <div class="col">{{ list[1].name }}：{{ list[1].value }}{{ list[1].unitName }}</div>
          </div>
          <div class="row row2" v-if="list[2]">
            <div class="col">
              <span class="label">{{ list[2].name }}</span>
              <span class="value">{{ list[2].value }}</span>
            </div>
            <div class="col">
              <span class="label">{{ list[2].unitName }}</span>
              <AlarmLevelIcon :state="list[2].warm" />
            </div>
          </div>
        </div>
        <div class="part2">
          <template v-for="item in bottomList[0]">
            <InfoBlock
              :key="item.code"
              :name="item.name"
              :unit="item.unitName"
              :value="item.value"
              :state="item.warm"
            />
          </template>
        </div>
      </div>
      <div class="part-container">
        <div class="part1">
          <div class="row row1">
            <div class="col align-right">
              <el-button type="primary" @click="workMode">工作模式</el-button>
              <el-button type="primary" @click="deviceInfo">设备信息</el-button>
            </div>
          </div>
          <div class="row row2" v-if="list[3]">
            <div class="col">
              <span class="label">{{ list[3].name }}</span>
              <span class="value">{{ list[3].value }}</span>
            </div>
            <div class="col">
              <span class="label">{{ list[3].unitName }}</span>
              <AlarmLevelBar :state="list[3].warm" />
            </div>
          </div>
        </div>
        <div class="part2">
          <template v-for="item in bottomList[1]">
            <InfoBlock
              :key="item.code"
              :name="item.name"
              :unit="item.unitName"
              :value="item.value"
              :state="item.warm"
            />
          </template>
        </div>
      </div>
      <DeviceInfo :sn="sn" :deviceType="deviceType" ref="deviceInfo" />
      <WorkMode :sn="sn" :deviceType="deviceType" :ac1000Mod="ac1000Mod" ref="workMode" />
    </div>
  </MonitorWrapper>
</template>

<script>
import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import AlarmLevelBar from './component/AlarmLevelBar.vue';
import AlarmLevelIcon from './component/AlarmLevelIcon.vue';
import InfoBlock from './component/InfoBlock.vue';
import DeviceInfo from './component/DeviceInfo.vue';
import WorkMode from './component/WorkMode.vue';

export default {
  components: {
    AlarmLevelIcon,
    AlarmLevelBar,
    InfoBlock,
    WorkMode,
    DeviceInfo
  },
  mixins: [singleDeviceMixin],
  data() {
    return {
      basicFontSize: 13,
      /** 前两个为固定传感器 */
      list: [
        { name: '温度', unitName: '℃', value: '', warm: 0 },
        { name: '湿度', unitName: '%', value: '', warm: 0 }
      ],
      timer: null,
      ac1000Mod: null
    };
  },
  computed: {
    bottomList() {
      /** @type {[]} */
      const list = this.list.slice(4);
      const len = Math.ceil(list.length / 2);
      return [list.slice(0, len), list.slice(len, len * 2)];
    }
  },
  methods: {
    workMode() {
      this.$refs.workMode.show();
    },
    deviceInfo() {
      this.$refs.deviceInfo.show();
    },
    setBg(flag) {
      document.querySelector('.main-content').style.background = flag ? '#000024' : 'unset';
    },
    updateData(res) {
      try {
        const { mods } = res || {};
        if (!mods || !mods.ac1000Mod) return;
        const ac1000Mod = (this.ac1000Mod = mods.ac1000Mod);
        const sensors = ac1000Mod.sensors;

        this.list[0].unit = ac1000Mod.tempUnitName;
        this.list[0].value = ac1000Mod.temp;

        this.list[1].unit = ac1000Mod.humidityUnitName;
        this.list[1].value = ac1000Mod.humidity;

        this.list.splice(2, Infinity, ...sensors);
      } catch (error) {
        console.error('----HT01: update failed!', error);
      }
      // console.table(JSON.parse(JSON.stringify(res.mods.ht01Mod.param)));
    }
  },
  mounted() {
    this.setBg(true);
    function getSize(n) {
      return (n - 1700) / 67 + 13;
    }
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.contentBoxSize) {
          // Firefox implements `contentBoxSize` as a single content rect, rather than an array
          const contentBoxSize = Array.isArray(entry.contentBoxSize)
            ? entry.contentBoxSize[0]
            : entry.contentBoxSize;

          this.basicFontSize = Math.max(13, getSize(contentBoxSize.inlineSize));
        } else {
          this.basicFontSize = Math.max(13, getSize(entry.contentRect.width));
        }
      }
    });
    resizeObserver.observe(document.querySelector('.security-guard-container'));
  },
  beforeDestroy() {
    this.setBg();
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss">
.security-guard-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 100%;

  .part-container {
    flex: 0 0 calc(50% - 10px);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    user-select: none;
    line-height: 1;

    .part1 {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      height: 38%;

      .row {
        .col {
          width: 50%;
          &:nth-of-type(1) {
            box-sizing: border-box;
            padding-left: 6%;
          }
        }
      }

      .row1 {
        flex: 1;
        display: flex;

        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;

        &.left {
          font-size: 3.125em;
        }

        .align-right {
          flex: 1;
          display: flex;
          justify-content: flex-end;

          .el-button {
            width: 11em;
            height: 4em;
            background: #00ffff;
            border-radius: 10px;

            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #000024;

            span {
              font-size: 2em;
            }
          }
        }
      }

      .row2 {
        flex: 2;

        display: flex;
        & > * {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .label {
          font-size: 3.6em;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
        }

        .value {
          font-size: 7.5em;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }

    .part2 {
      display: flex;
      flex-direction: column;
      height: 55%;

      .info-block {
        margin-bottom: 20px;
      }

      & > * {
        flex: 0 0 calc(33% - 13.33px);
      }
    }
  }
}
</style>
